export const productManagerConstants = {
  ID: 'id',
  PRODUCT_CATEGORY: 'product_category_id',
  PRODUCT_CATEGORY_LABEL: 'Category',
  PRODUCT_SUB_CATEGORY: 'product_sub_category_id',
  PRODUCT_SUB_CATEGORY_LABEL: 'Sub-Category',
  NAME: 'name',
  NAME_LABEL: 'Name',
  REMOVE_CONFIRM: 'Are you sure?',
  SERVICES: 'Services',
  SERVICE_CATEGORIES: 'Service Categories',
  CREATE_SERVICE: 'Create Service',
  SEARCH_SERVICE: 'Search Services',
  RECURRING: 'is_recurring',
  RECURRING_LABEL: 'Recurring',
  IMAGE: 'image',
  IMAGE_NAME: 'image_name',
  IMAGE_LABEL: 'Image',
  EXT_REF: 'ext_reference_id',
  EXT_REF_LABEL: 'External Reference',
  ORDER: 'order',
  ORDER_LABEL: 'Order',

  IS_RECURRING: 'is_recurring',
  IS_RECURRING_LABEL: 'Recurring',

  NEEDS_CUSTOMER_SUPPORT: 'needs_customer_support',
  NEEDS_CUSTOMER_SUPPORT_LABEL: 'Needs Customer Support',

  PRODUCT_SUB_CATEGORIES: 'product_sub_categories',
  PRODUCT_SUB_CATEGORIES_LABEL: 'Sub Categories',
  ADD_SUB_CATEGORY: 'Add Sub Category',

  API_CLIENTS: 'Product Manager API Clients',

  API_CLIENT_NAME: 'api_client_name',

  REP: 'rep_id',
  REP_LABEL: 'Rep Name',

  DESCRIPTION: 'description',
  DESCRIPTION_LABEL: 'Description',
};
